import React from 'react'
import classNames from 'classnames'

import './NoData.scss'

/**
 * @param {React.ReactNode} icon - optional glyph above the header, for empty
 *   states that want to say something about what is missing
 */
const NoData = ({
  text,
  headerText,
  position,
  muted,
  padded,
  children,
  icon,
  hideHeader = false,
  ...props
}) => {
  return (
    <div
      className={classNames('no-data-container', {
        'left-aligned': position === 'left',
        muted,
        padded,
      })}
      {...props}
    >
      <div>
        {icon && <div className="no-data-icon">{icon}</div>}
        {!hideHeader && <h3>{headerText || 'Nothing to display'}</h3>}
        {!children && <p>{text || 'No data meets the filter criteria'}</p>}
        {children}
      </div>
    </div>
  )
}

export default NoData
